import React from 'react'

const IconUnChecked = ({ width = '16px', height = '16px', fill = '#3d3d3d' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 32 32"
  >
    <path
      fill={fill}
      d="M21.6 29.333H10.4c-2.4 0-3.733 0-4.8-.533-1.067-.534-1.867-1.334-2.267-2.267-.666-1.2-.666-2.533-.666-4.933V10.4c0-2.4 0-3.734.533-4.8.533-1.067 1.333-1.867 2.267-2.267 1.2-.667 2.533-.667 4.933-.667h10.933c.8 0 1.334.534 1.334 1.334s-.534 1.333-1.334 1.333H10.4c-2 0-3.067 0-3.6.267a2.6 2.6 0 0 0-1.2 1.2c-.267.533-.267 1.6-.267 3.6v11.2c0 2 0 3.066.267 3.6q.4.8 1.2 1.2c.533.267 1.6.267 3.6.267h11.2c2 0 3.067 0 3.6-.267a2.6 2.6 0 0 0 1.2-1.2c.267-.534.267-1.6.267-3.6V16c0-.8.533-1.334 1.333-1.334s1.333.534 1.333 1.334v5.6c0 2.4 0 3.733-.533 4.8s-1.333 1.867-2.267 2.267c-1.2.666-2.533.666-4.933.666"
    ></path>
  </svg>
)

export default IconUnChecked
